import React, { useState } from 'react';
import { Dialog } from '@blueprintjs/core';
import { Button, TextAreaLimited } from 'components';
import { useMutation } from '@apollo/client';
import { REJECT_DATA_FIX_MUTATION } from 'gql';
import { useModal } from 'providers/modalProvider';
import { useToast } from 'providers/toastProvider';
import { useIntl } from 'react-intl';
import { path } from 'ramda';
import { buildActionSummary } from 'utils/dataFixSummary';

const RejectDataFixModal = () => {
  const { modalDispatch, modalState } = useModal();
  const { showToast } = useToast();
  const { formatMessage } = useIntl();
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const { row, refetch, onSuccess } = path(['payload'], modalState) ?? {};

  const closeModal = () => modalDispatch({ type: 'CLOSE_ALL' });

  const [reject, { loading }] = useMutation(REJECT_DATA_FIX_MUTATION, {
    onCompleted: () => {
      showToast({
        message: formatMessage({
          id: 'containers.dataFixes.modals.reject.success',
        }),
      });
      closeModal();
      refetch?.();
      onSuccess?.();
    },
    onError: () =>
      showToast({
        message: formatMessage({ id: 'containers.all.error' }),
        icon: 'error',
      }),
  });

  const handleReject = () => {
    if (!reason.trim()) {
      setError(
        formatMessage({ id: 'containers.dataFixes.modals.reject.reason' }),
      );
      return;
    }
    reject({ variables: { input: { id: row.id, reason } } });
  };

  return (
    <Dialog
      isOpen={modalState?.open}
      title={formatMessage({ id: 'containers.dataFixes.modals.reject.title' })}
      onClose={closeModal}
      canOutsideClickClose={false}
    >
      <div className="bp3-dialog-body">
        <p className="mgb-10">
          <strong>{buildActionSummary(row)}</strong>
        </p>
        <TextAreaLimited
          onChange={(e) => {
            setReason(e.target.value);
            setError('');
          }}
          value={reason}
          placeholder={formatMessage({
            id: 'containers.dataFixes.modals.reject.reason',
          })}
          maxLength="500"
          showMaxLength
          error={error}
          className="mgt-10"
        />
      </div>
      <div className="bp3-dialog-footer-actions">
        <Button
          outlined
          text={formatMessage({ id: 'containers.all.btn.cancel' })}
          onClick={closeModal}
          disabled={loading}
        />
        <Button
          intent="Danger"
          text={formatMessage({ id: 'containers.dataFixes.actions.reject' })}
          onClick={handleReject}
          loading={loading}
        />
      </div>
    </Dialog>
  );
}

export default RejectDataFixModal;
